import styled from 'styled-components';
import { darken } from 'polished';

export const StyledAddTab = styled.span`
  display: flex;
  background-color: #ffffff;
  height: 1.9rem;
  min-width: 1.5rem;
  justify-content: center;
  font-size: 0.875rem;
  transition: background-color 0.1s ease-in-out, width 0.5s linear;
  border: 1px solid rgb(222, 226, 230);
  border-bottom: 1px solid rgb(185 188 192);

  border-radius: 0rem 0.25rem 0.25rem 0rem;
  font-size: 1.2rem;
  cursor: pointer;

  &:hover {
    color: ${darken(0.2, '#74637f')};
    background-color: #ced1d7;
  }
`;
